import { Map, List } from 'immutable';

export function normalizeIds(list, key = 'id') {
  if (!list || !list.length) {
    return List();
  }

  return List(list.map((elem) => elem[key]));
}

export function normalizeModelList(list, deserializeFn, key = 'id') {
  if (!list || !list.length) {
    return Map();
  }

  return list.reduce(
    (acc, elem) => acc.set(elem[key], deserializeFn ? deserializeFn(elem) : elem),
    Map(),
  );
}

export function denormalizeModelList(byId, ids) {
  return ids.map((id) => byId.get(id));
}
